import { MapUiTheme } from '../../common';
import { padding } from '../../common/theme/utils';

export const alertTheme = {
  defaultStyles: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: (theme: MapUiTheme) => theme.borderRadius.lg,
    background: (theme: MapUiTheme) => theme.colors.black,
    color: (theme: MapUiTheme) => theme.colors.white,
    lineHeight: (theme: MapUiTheme) => theme.lineHeight.normal,
  },
  info: {
    background: (theme: MapUiTheme) => theme.colors.interaction300,
    color: (theme: MapUiTheme) => theme.colors.white,
    border: 'none',
  },
  warning: {
    background: (theme: MapUiTheme) => theme.colors.warning300,
    color: (theme: MapUiTheme) => theme.colors.white,
    border: 'none',
  },
  success: {
    background: (theme: MapUiTheme) => theme.colors.success300,
    color: (theme: MapUiTheme) => theme.colors.white,
    border: 'none',
  },
  error: {
    background: (theme: MapUiTheme) => theme.colors.danger300,
    color: (theme: MapUiTheme) => theme.colors.white,
    border: 'none',
  },
  neutral: {
    background: (theme: MapUiTheme) => theme.colors.neutral300,
    color: (theme: MapUiTheme) => theme.colors.white,
    border: 'none',
  },
  xs: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['2'],
      (theme: MapUiTheme) => theme.spacing['3']
    ),
  },
  sm: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['3'],
      (theme: MapUiTheme) => theme.spacing['4']
    ),
  },
  md: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['4'],
      (theme: MapUiTheme) => theme.spacing['4']
    ),
  },
  lg: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['5'],
      (theme: MapUiTheme) => theme.spacing['4']
    ),
  },
  xl: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['6'],
      (theme: MapUiTheme) => theme.spacing['5']
    ),
  },
};
